import React from 'react';
import { ShieldCheck } from 'lucide-react';
import FacturacionFormSection from '../FacturacionFormSection';

export default function SolicitanteForm({ solicitante, handleSolicitante }) {
  return (
    <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', marginBottom: '1.5rem' }}>
      <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '1.5rem', marginTop: 0 }}>
        <ShieldCheck size={20} color="#0f172a" />
        Datos del Solicitante
      </h3>
      
      {/* Campo oculto Honeypot (Antispam) */}
      <input 
        type="text" 
        name="_hp_website_email" 
        style={{ display: 'none' }} 
        tabIndex="-1" 
        autoComplete="off" 
        value={solicitante._hp_website_email} 
        onChange={handleSolicitante} 
      />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem', marginBottom: '1rem' }}>
        <div>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>RUT *</label>
          <input
            name="rut_solicitante"
            value={solicitante.rut_solicitante}
            onChange={handleSolicitante}
            placeholder="12.345.678-9"
            maxLength={12}
            autoComplete="off"
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
            onFocus={e => e.target.style.borderColor = 'var(--primary)'}
            onBlur={e => e.target.style.borderColor = '#cbd5e1'}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Nombre Completo *</label>
          <input
            name="nombre_solicitante"
            value={solicitante.nombre_solicitante}
            onChange={handleSolicitante}
            placeholder="Juan Pérez"
            autoComplete="name"
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
            onFocus={e => e.target.style.borderColor = 'var(--primary)'}
            onBlur={e => e.target.style.borderColor = '#cbd5e1'}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Correo Electrónico *</label>
          <input
            type="email"
            name="email"
            value={solicitante.email}
            onChange={handleSolicitante}
            placeholder="correo@ejemplo.cl"
            autoComplete="email"
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
            onFocus={e => e.target.style.borderColor = 'var(--primary)'}
            onBlur={e => e.target.style.borderColor = '#cbd5e1'}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#334155', marginBottom: '0.4rem' }}>Teléfono de Contacto</label>
          <input
            type="tel"
            name="telefono"
            value={solicitante.telefono}
            onChange={handleSolicitante}
            placeholder="+56 9..."
            autoComplete="tel"
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.9rem', outline: 'none' }}
            onFocus={e => e.target.style.borderColor = 'var(--primary)'}
            onBlur={e => e.target.style.borderColor = '#cbd5e1'}
          />
        </div>
      </div>

      {/* Sección de Facturación / Boleta */}
      <FacturacionFormSection
        billingData={{
          facturacion_misma_persona: solicitante.facturacion_misma_persona ?? true,
          boleta_rut: solicitante.rut_boleta || '',
          boleta_razon_social: solicitante.boleta_razon_social || '',
          boleta_giro: solicitante.boleta_giro || '',
          boleta_direccion: solicitante.boleta_direccion || '',
          boleta_correo: solicitante.boleta_correo || ''
        }}
        onChange={(newBilling) => {
          handleSolicitante({
            target: {
              name: 'billing_update',
              value: newBilling
            }
          });
        }}
        solicitanteData={solicitante}
      />
    </div>
  );
}
